import React            from 'react'
import { List }         from 'antd'
import classNames       from 'classnames'
import bellIcon         from '../../../assets/svg/notification.svg'
import './styles.scss'

export default function NotifyList({notifications = [], onClick, onClear}) {
  return (
    <div className={'notify-list'}>
      {
        notifications.filter(n=> !n.read).length > 0 ?
          <div className={'clear'} onClick={onClear}>
            {'clear'}
          </div> : null
      }
      {
        notifications.filter(n=> !n.read).length === 0 ? (
          <div className={'empty'}>
            <img src={bellIcon} alt="not found"/>
            <span>No notifications. Cool.</span>
          </div>
        ) :
          <List>
            {notifications.map((item, i) => {
              return (
                <List.Item className={ classNames('item', {['read']: item.read})} key={item.key || i} onClick={() => onClick(item)}>
                  <List.Item.Meta
                    className={'meta'}
                    /*avatar={item.avatar ? item.avatar : null}*/
                    /*avatar={item.avatar ? <Avatar className={'avatar'} src={item.avatar} /> : null}*/
                    avatar={item.avatar ? <img className={'avatar'} src={item.avatar} /> : null}

                    title={
                      <div className={'title'}>
                        {item.title}
                        <div className={'extra'}>{item.extra}</div>
                      </div>
                    }

                    description={
                      <div>
                        <div className={'description'} title={item.description}>
                          {item.description}
                        </div>
                        <div className={'datetime'}>{item.last_notified}</div>
                      </div>
                    }
                  />
                </List.Item>
              )
            })}
          </List>
      }
    </div>
  )
}
